
// import React, { useState } from 'react';
// import {
//   Box,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   Alert,
//   Link,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Divider,
//   GlobalStyles,
//   ThemeProvider,
//   createTheme,
//   useMediaQuery,
// } from '@mui/material';
// import {
//   Email,
//   Lock,
//   Visibility,
//   VisibilityOff,
//   Security,
//   VerifiedUser,
//   TrendingDown,
//   ArrowUpward,
//   FiberManualRecord,
// } from '@mui/icons-material';
// import { useNavigate, Link as RouterLink } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// /**
//  * ── DESIGN TOKENS ─────────────────────────────────────────────────────────
//  * This page is intentionally locked to a single, light appearance.
//  * It does NOT read from the app's shared theme and does NOT respond to the
//  * OS/browser "prefers-color-scheme: dark" setting — see `colorScheme: 'light'`
//  * below, which also forces native form chrome (autofill, date pickers,
//  * scrollbars) to render light.
//  */
// const palette = {
//   ink: '#0B1220', // primary text / headlines
//   inkSoft: '#2A3342', // secondary headings
//   muted: '#5B6472', // body / captions
//   faint: '#8A93A3', // tertiary labels
//   paper: '#FBFAF7', // warm off-white page background (form side)
//   card: '#FFFFFF',
//   border: '#E7E3D8',
//   ledger: '#0E1B2E', // deep navy — signature "ledger" panel
//   ledgerLine: 'rgba(255,255,255,0.08)',
//   teal: '#0F766E', // primary accent (brand) — used sparingly & deliberately
//   tealDark: '#0B5C56',
//   tealSoft: 'rgba(15,118,110,0.10)',
//   amber: '#D97706',
//   red: '#DC2626',
//   green: '#16A34A',
// };

// // Force a fixed, light-only MUI theme for this page regardless of any
// // dark-mode ThemeProvider higher up in the app.
// const lightOnlyTheme = createTheme({
//   palette: {
//     mode: 'light',
//     background: { default: palette.paper, paper: palette.card },
//     text: { primary: palette.ink, secondary: palette.muted },
//   },
//   typography: {
//     fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
//   },
// });

// export default function Login() {
//   const isMobile = useMediaQuery('(max-width:960px)');
//   const navigate = useNavigate();
//   const { login } = useAuth();

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//   });

//   const inputSx = {
//     '& .MuiOutlinedInput-root': {
//       borderRadius: '8px',
//       fontSize: '1rem',
//       color: palette.ink,
//       bgcolor: palette.card,
//       '& input': { py: 1.85 },
//       '& input:-webkit-autofill': {
//         WebkitBoxShadow: `0 0 0 100px ${palette.card} inset`,
//         WebkitTextFillColor: palette.ink,
//       },
//       '& fieldset': { borderColor: palette.border },
//       '&:hover fieldset': { borderColor: '#C7C1B0' },
//       '&.Mui-focused fieldset': { borderColor: palette.teal, borderWidth: '1.5px' },
//     },
//     '& .MuiInputLabel-root': { color: palette.muted, fontSize: '0.95rem' },
//     '& .MuiInputLabel-root.Mui-focused': { color: palette.tealDark },
//   };

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setError('');
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       await login(formData.email, formData.password);
//       navigate('/dashboard');
//     } catch (err: any) {
//       setError(err.message || 'Invalid credentials. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const ledger = [
//     { time: '09:41:03', vendor: 'Meridian Cloud Services', delta: -12, tag: 'CVE-2026-11284 disclosed' },
//     { time: '09:38:47', vendor: 'Northwind Payments', delta: 4, tag: 'SOC 2 Type II renewed' },
//     { time: '09:22:15', vendor: 'Argosy Data Labs', delta: -6, tag: 'TLS cert expires in 14d' },
//     { time: '09:05:52', vendor: 'Halcyon Logistics', delta: -3, tag: 'Subprocessor added' },
//   ];

//   return (
//     <ThemeProvider theme={lightOnlyTheme}>
//       {/* Fonts + hard lock to light color-scheme (kills OS dark-mode form chrome) */}
//       <GlobalStyles
//         styles={{
//           '@import':
//             "url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap')",
//           ':root': { colorScheme: 'light' },
//           html: { colorScheme: 'light' },
//           body: { colorScheme: 'light', backgroundColor: palette.paper },
//         }}
//       />
//       <Box
//         sx={{
//           minHeight: '100vh',
//           display: 'flex',
//           bgcolor: palette.paper,
//           colorScheme: 'light',
//         }}
//       >
//         {/* ─── LEFT PANEL — "Live Ledger" (signature element) ─────────────── */}
//         {!isMobile && (
//           <Box
//             sx={{
//               flex: '1 1 52%',
//               maxWidth: '52%',
//               bgcolor: palette.ledger,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//               px: { md: 6, lg: 9 },
//               py: 6,
//               position: 'relative',
//               overflow: 'hidden',
//             }}
//           >
//             {/* faint grid texture */}
//             <Box
//               sx={{
//                 position: 'absolute',
//                 inset: 0,
//                 backgroundImage:
//                   'linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)',
//                 backgroundSize: '48px 48px',
//                 maskImage: 'radial-gradient(ellipse 75% 55% at 25% 15%, black, transparent)',
//               }}
//             />
//             <Box
//               sx={{
//                 position: 'absolute',
//                 top: -180,
//                 left: -140,
//                 width: 480,
//                 height: 480,
//                 borderRadius: '50%',
//                 background: `radial-gradient(circle, ${palette.tealSoft} 0%, transparent 70%)`,
//                 filter: 'blur(6px)',
//               }}
//             />

//             <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 520 }}>
//               <Box
//                 sx={{
//                   display: 'inline-flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   bgcolor: 'rgba(15,118,110,0.16)',
//                   border: '1px solid rgba(94,234,212,0.25)',
//                   borderRadius: '999px',
//                   px: 1.6,
//                   py: 0.5,
//                   mb: 4.5,
//                 }}
//               >
//                 <FiberManualRecord sx={{ fontSize: 8, color: '#5EEAD4' }} />
//                 <Typography
//                   sx={{
//                     fontFamily: "'IBM Plex Mono', monospace",
//                     fontSize: 11.5,
//                     letterSpacing: '0.08em',
//                     color: '#99F6E4',
//                     fontWeight: 500,
//                   }}
//                 >
//                   LIVE VENDOR RISK LEDGER
//                 </Typography>
//               </Box>

//               <Typography
//                 sx={{
//                   fontFamily: "'Fraunces', serif",
//                   fontWeight: 500,
//                   color: '#F5F4F0',
//                   fontSize: { md: 33, lg: 40 },
//                   lineHeight: 1.16,
//                   letterSpacing: '-0.01em',
//                   mb: 2.5,
//                 }}
//               >
//                 Know your vendor risk before it becomes your incident.
//               </Typography>

//               <Typography
//                 sx={{
//                   color: 'rgba(226,232,240,0.72)',
//                   fontSize: 16,
//                   lineHeight: 1.7,
//                   mb: 5,
//                   fontFamily: "'Inter', sans-serif",
//                 }}
//               >
//                 Continuous scoring, control evidence, and breach intelligence
//                 across every supplier in your ecosystem — updated as it happens,
//                 not once a year.
//               </Typography>

//               {/* Ledger table */}
//               <Box
//                 sx={{
//                   border: `1px solid ${palette.ledgerLine}`,
//                   borderRadius: '10px',
//                   overflow: 'hidden',
//                   mb: 5,
//                   bgcolor: 'rgba(255,255,255,0.02)',
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     px: 2.2,
//                     py: 1.2,
//                     borderBottom: `1px solid ${palette.ledgerLine}`,
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       fontSize: 10.5,
//                       letterSpacing: '0.09em',
//                       color: 'rgba(226,232,240,0.45)',
//                     }}
//                   >
//                     TIMESTAMP
//                   </Typography>
//                   <Typography
//                     sx={{
//                       fontFamily: "'IBM Plex Mono', monospace",
//                       fontSize: 10.5,
//                       letterSpacing: '0.09em',
//                       color: 'rgba(226,232,240,0.45)',
//                     }}
//                   >
//                     Δ SCORE
//                   </Typography>
//                 </Box>

//                 {ledger.map((row, i) => (
//                   <Box
//                     key={row.vendor}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       px: 2.2,
//                       py: 1.3,
//                       borderTop: i === 0 ? 'none' : `1px solid ${palette.ledgerLine}`,
//                     }}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, minWidth: 0 }}>
//                       <Typography
//                         sx={{
//                           fontFamily: "'IBM Plex Mono', monospace",
//                           fontSize: 11.5,
//                           color: 'rgba(226,232,240,0.4)',
//                           flexShrink: 0,
//                         }}
//                       >
//                         {row.time}
//                       </Typography>
//                       <Box sx={{ minWidth: 0 }}>
//                         <Typography
//                           sx={{
//                             color: '#F1F0EC',
//                             fontSize: 13.5,
//                             fontWeight: 500,
//                             lineHeight: 1.25,
//                             whiteSpace: 'nowrap',
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                           }}
//                         >
//                           {row.vendor}
//                         </Typography>
//                         <Typography sx={{ color: 'rgba(226,232,240,0.45)', fontSize: 11.5 }}>
//                           {row.tag}
//                         </Typography>
//                       </Box>
//                     </Box>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, flexShrink: 0, pl: 1.5 }}>
//                       {row.delta < 0 ? (
//                         <TrendingDown sx={{ fontSize: 15, color: '#F87171' }} />
//                       ) : (
//                         <ArrowUpward sx={{ fontSize: 13, color: '#4ADE80' }} />
//                       )}
//                       <Typography
//                         sx={{
//                           fontFamily: "'IBM Plex Mono', monospace",
//                           fontSize: 13,
//                           fontWeight: 500,
//                           color: row.delta < 0 ? '#F87171' : '#4ADE80',
//                         }}
//                       >
//                         {row.delta > 0 ? `+${row.delta}` : row.delta}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>

//               <Box
//                 sx={{
//                   display: 'grid',
//                   gridTemplateColumns: 'repeat(3, 1fr)',
//                   gap: 2,
//                   mb: 5,
//                 }}
//               >
//                 {[
//                   { value: '12,400+', label: 'Vendors assessed' },
//                   { value: '3.2 min', label: 'Avg. alert latency' },
//                   { value: '99.95%', label: 'Platform uptime' },
//                 ].map((s) => (
//                   <Box key={s.label}>
//                     <Typography
//                       sx={{
//                         fontFamily: "'IBM Plex Mono', monospace",
//                         color: '#F5F4F0',
//                         fontWeight: 500,
//                         fontSize: 19,
//                       }}
//                     >
//                       {s.value}
//                     </Typography>
//                     <Typography sx={{ color: 'rgba(226,232,240,0.5)', fontSize: 12, mt: 0.4 }}>
//                       {s.label}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 0.7,
//                     bgcolor: 'rgba(255,255,255,0.04)',
//                     border: `1px solid ${palette.ledgerLine}`,
//                     borderRadius: '999px',
//                     px: 1.4,
//                     py: 0.6,
//                   }}
//                 >
//                   <Security sx={{ fontSize: 14, color: 'rgba(226,232,240,0.6)' }} />
//                   <Typography sx={{ color: 'rgba(226,232,240,0.75)', fontSize: 12 }}>
//                     ISO 27001 Certified
//                   </Typography>
//                 </Box>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 0.7,
//                     bgcolor: 'rgba(255,255,255,0.04)',
//                     border: `1px solid ${palette.ledgerLine}`,
//                     borderRadius: '999px',
//                     px: 1.4,
//                     py: 0.6,
//                   }}
//                 >
//                   <VerifiedUser sx={{ fontSize: 14, color: 'rgba(226,232,240,0.6)' }} />
//                   <Typography sx={{ color: 'rgba(226,232,240,0.75)', fontSize: 12 }}>
//                     SOC 2 Type II
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         )}

//         {/* ─── RIGHT PANEL — Sign in form ──────────────────────────────────── */}
//         <Box
//           sx={{
//             flex: { xs: '1 1 100%', md: '1 1 48%' },
//             maxWidth: { xs: '100%', md: '48%' },
//             width: '100%',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             p: { xs: 3, md: 5 },
//             bgcolor: palette.paper,
//             minHeight: '100vh',
//           }}
//         >
//           <Paper
//             elevation={0}
//             sx={{
//               width: '100%',
//               maxWidth: 480,
//               p: 0,
//               borderRadius: 3,
//               bgcolor: 'transparent',
//             }}
//           >
//             {/* Logo — large, always the first thing you see */}
//             <Box sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start', mb: isMobile ? 5 : 6 }}>
//               <img
//                 src="/logo.png"
//                 alt="Platform logo"
//                 style={{ height: isMobile ? 84 : 108, width: 'auto' }}
//               />
//             </Box>

//             <Box sx={{ mb: 5 }}>
//               <Typography
//                 sx={{
//                   fontFamily: "'Fraunces', serif",
//                   fontWeight: 500,
//                   color: palette.ink,
//                   fontSize: 30,
//                   letterSpacing: '-0.01em',
//                   mb: 1,
//                 }}
//               >
//                 Sign in to your workspace
//               </Typography>
//               <Typography sx={{ color: palette.muted, fontSize: 15.5 }}>
//                 Enter your credentials to access your risk dashboard
//               </Typography>
//             </Box>

//             {error && (
//               <Alert severity="error" sx={{ mb: 3, borderRadius: '8px' }}>
//                 {error}
//               </Alert>
//             )}

//             <form onSubmit={handleSubmit}>
//               <Typography
//                 component="label"
//                 htmlFor="login-email"
//                 sx={{ display: 'block', fontSize: 13, fontWeight: 600, color: palette.inkSoft, mb: 0.8 }}
//               >
//                 Email address
//               </Typography>
//               <TextField
//                 id="login-email"
//                 fullWidth
//                 name="email"
//                 type="email"
//                 placeholder="you@company.com"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 sx={{ mb: 3, ...inputSx }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Email sx={{ color: palette.faint, fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.8 }}>
//                 <Typography
//                   component="label"
//                   htmlFor="login-password"
//                   sx={{ fontSize: 13, fontWeight: 600, color: palette.inkSoft }}
//                 >
//                   Password
//                 </Typography>
//                 <Link
//                   component="button"
//                   type="button"
//                   onClick={() => navigate('/forgot-password')}
//                   underline="hover"
//                   sx={{
//                     color: palette.tealDark,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     cursor: 'pointer',
//                     bgcolor: 'transparent',
//                     border: 'none',
//                     '&:hover': { color: palette.teal },
//                   }}
//                 >
//                   Forgot password?
//                 </Link>
//               </Box>
//               <TextField
//                 id="login-password"
//                 fullWidth
//                 name="password"
//                 type={showPassword ? 'text' : 'password'}
//                 placeholder="••••••••"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//                 sx={{ mb: 4, ...inputSx }}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: palette.faint, fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
//                         {showPassword ? (
//                           <VisibilityOff sx={{ color: palette.faint, fontSize: 20 }} />
//                         ) : (
//                           <Visibility sx={{ color: palette.faint, fontSize: 20 }} />
//                         )}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Button
//                 fullWidth
//                 type="submit"
//                 variant="contained"
//                 size="large"
//                 disabled={loading}
//                 disableElevation
//                 sx={{
//                   py: 1.7,
//                   borderRadius: '8px',
//                   bgcolor: palette.teal,
//                   boxShadow: 'none',
//                   '&:hover': { bgcolor: palette.tealDark, boxShadow: 'none' },
//                   '&.Mui-disabled': { bgcolor: '#D7D2C4', color: '#fff' },
//                   textTransform: 'none',
//                   fontWeight: 600,
//                   fontSize: 15.5,
//                 }}
//               >
//                 {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Sign in'}
//               </Button>

              

              

//               <Typography textAlign="center" sx={{ color: palette.muted, mt: 5, fontSize: 14.5 }}>
//                 Don't have an account?{' '}
//                 <Link
//                   component={RouterLink}
//                   to="/signup"
//                   underline="hover"
//                   sx={{ color: palette.tealDark, fontWeight: 600 }}
//                 >
//                   Sign up
//                 </Link>
//               </Typography>
//             </form>
//           </Paper>
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// }

import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router-dom';
import { EmailOutlined, LockOutlined } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import AuthLayout, { AuthAlert, AuthField, PasswordToggle, Spinner } from './auth/AuthLayout';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [searchParams] = useSearchParams();
  const signedOutForIdle = searchParams.get('reason') === 'idle';
  const signedOutByAdmin = searchParams.get('reason') === 'revoked';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(formData.email, formData.password);
      navigate(user?.require_password_reset ? '/change-password' : '/dashboard');
    } catch (err: any) {
      setError(err.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout variant="login">
      <h1 className="fwa-title">Welcome back</h1>
      <p className="fwa-sub">Sign in to your FluxWatch workspace.</p>

      {!error && signedOutByAdmin && (
        <AuthAlert tone="info">Your session was ended by an administrator. Sign in again to continue.</AuthAlert>
      )}
      {!error && signedOutForIdle && (
        <AuthAlert tone="info">You were signed out after a period of inactivity. Sign in again to continue.</AuthAlert>
      )}
      {error && <AuthAlert>{error}</AuthAlert>}

      <form onSubmit={handleSubmit}>
        <AuthField
          id="login-email"
          label="Work email"
          icon={<EmailOutlined />}
          name="email"
          type="email"
          autoComplete="email"
          placeholder="you@company.com"
          value={formData.email}
          onChange={handleChange}
          required
          autoFocus
        />
        <AuthField
          id="login-password"
          label="Password"
          icon={<LockOutlined />}
          labelRight={<button type="button" className="fwa-link" style={{ fontSize: 13 }} onClick={() => navigate('/forgot-password')}>Forgot password?</button>}
          trailing={<PasswordToggle shown={showPassword} onToggle={() => setShowPassword(!showPassword)} />}
          name="password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="current-password"
          placeholder="Enter your password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <div style={{ height: 8 }} />
        <button className="fwa-btn" type="submit" disabled={loading}>
          {loading ? <Spinner /> : 'Sign in'}
        </button>
      </form>

      <p className="fwa-foot">
        New to FluxWatch? <RouterLink className="fwa-link" to="/signup">Create an account</RouterLink>
      </p>
    </AuthLayout>
  );
}
